import { render, staticRenderFns } from "./facturePrint.vue?vue&type=template&id=7616283d&"
import script from "./facturePrint.vue?vue&type=script&lang=js&"
export * from "./facturePrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports